import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmWhatsAppFlowError } from '@/core/error/transport/customErrors/tmWhatsAppFlowError'

export const whatsAppFlowErrorRule: CustomErrorRule = {
  subCodes: ['whatsapp_business.invalid_pin', 'whatsapp_business.phone_already_exists'],
  klass: TmWhatsAppFlowError,
}
